<div class="archive-pagination" *ngIf="maxPages > 1">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-3">

      </div>
      <div class="col-12 col-lg-4 archive-pagination__next-button-wrapper" [ngClass]="{'archive-pagination__next-button-wrapper--disabled' : currentPage === maxPages}">
        <brt-button (click)="onNextPageClicked()" [size]="'x-large'" color="river" title="Weiter" [wide]="true"></brt-button>

      </div>
      <div class="col-12 col-lg-3 archive-pagination__navigation-wrapper">
        <div class="archive-pagination__navigation">
          <button role="button" class="archive-pagination__navigation-button" [ngClass]="{'disabled' : currentPage === 1}" (click)="onPrevPageClicked()" [disabled]="currentPage === 1">
            <brt-icon [icon]="'reg-chevron-left'"></brt-icon>
          </button>
          <input #inputElement class="archive-pagination__navigation-index" type="number" enterkeyhint="go" [ngModel]="currentPage" (change)="inputChanged($event)" (keydown)="onKeyUp($event)" (keyup)="onKeyUp($event)" min="1" [max]="maxPages" step="1">
          <button role="button" class="archive-pagination__navigation-button" [ngClass]="{'disabled' : currentPage === maxPages}" (click)="onNextPageClicked()" [disabled]="currentPage === maxPages">
            <brt-icon [icon]="'reg-chevron-right'"></brt-icon>
          </button>
        </div>
        <div class="archive-pagination__navigation-label">
          von {{ maxPages }}
        </div>

      </div>
    </div>
  </div>
</div>
